import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";

const ExpenseCompleted = () => (
  <Alert
    alignItems="top"
    gridTemplateColumns="max-content 1fr"
    display="grid"
    status="success"
    variant="top-accent"
  >
    <AlertIcon />
    <div>
      <AlertTitle>
        <Trans>All expenses are received</Trans>
      </AlertTitle>
      <AlertDescription>
        <Trans>Every expense budget item has all expenses received.</Trans>
      </AlertDescription>
    </div>
  </Alert>
);

export default ExpenseCompleted;
